import { Box } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import CommonButton from "../common/components/Buttons/CommonButton"; // Assuming you have a custom CommonButton component
import CommonTransactionPaginationTable from "../common/components/CommonTable/CommonDynamicTablePaginationNew";
import DropdownField from "../common/components/FormFields/DropdownField"; // Assuming you have a custom DropdownField component
import RadioField from "./../common/components/FormFields/RadioField";
import SearchDropdown from "./../common/components/FormFields/searchDropdown"; // Assuming you have a custom SearchDropdownField component
import LoadingSpinner from "./../common/components/loadingspinner/loadingSpinner";
import {
  getPatientMonitoringList,
  getStartMonitor,
} from "./PatientMonitoringServices";
import {
  errorAlert,
  successAlert,
} from "../common/components/Toasts/CustomToasts";
import CommonDynamicTableNew from "../common/components/CommonTable/CommonDynamicTableNew";

const bedArr = [
  { id: 1, value: "All", label: "All" },
  { id: 2, value: "1", label: "1" },
  { id: 3, value: "2", label: "2" },
  { id: 4, value: "3", label: "3" },
  { id: 5, value: "4", label: "4" },
  { id: 6, value: "5", label: "5" },
];

const icuWardArr = [
  { id: 1, value: "All", label: "All" },
  { id: 2, value: "NICU", label: "NICU" },
  { id: 3, value: "PICU", label: "PICU" },
  { id: 4, value: "ICU", label: "ICU" },
];
const doctorArr = [
  { value: "All", label: "All" },
  { value: "Prajwal", label: "Dr. Prajwal" },
  { value: "Alicia", label: "Dr. Alicia" },
  { value: "Shahjeb", label: "Dr. Shahjeb" },
];

let action = [
  { value: "All", label: "All", id: 2 },
  { value: "Start", label: "Start", id: 1 },
  { value: "Stop", label: "Stop", id: 0 },
];

const PatientMonitoring = () => {
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [patientName, setPatientName] = useState("");
  const [listingObject, setListingObject] = useState({
    page: 0,
    size: rowsPerPage,
    searchString: "",
    searchId: null,
    fromDate: null,
    toDate: null,
    unitId: null,
    menuId: null,
    patientType: null,
  });
  const {
    control,
    setValue,
    reset,
    watch,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      action: 2,
      ward: null,
      bedNo: null,
      patientName: null,
      doctor: null,
    },
  });

  const actionValues = watch("action");
  const bedNoValues = watch("bedNo");
  const wardValues = watch("ward");
  const doctorValues = watch("doctor");
  const patientValues = watch("patientName");

  const populateTable = (forPagination) => {
    let searchObj = {
      //   page: !forPagination ? 0 : page,
      //   searchString: "",
      //   size: rowsPerPage,
      //   searchId: searchString?.id ? searchString?.id : null,
      //   patientName: patientValues !== null ? patientValues?.id : null,
      //   bedNo: bedNoValues !== null ? bedNoValues?.id : null,
      //   ward: wardValues !== null ? wardValues?.id : null,
      //   doctor: doctorValues !== null ? doctorValues?.id : null,
      //   status: actionValues === "Start" ? 1 : actionValues === "Stop" ? 0 : 2,
      admissionId: null,
      bedId: null,
      wardId: null,
      doctorId: null,
      status: null,
    };

    getPatientMonitoringList(searchObj)
      .then((response) => {
        setDataResult(response.data.result);
      })
      .catch((error) => error.message);
  };

  const renderInput = (row, index, header) => {
    const handleToggle = () => {
      let tempObj = {
        monitorIp: row?.hostname,
        status: row?.Action === 0 ? true : false,
        admissionId: row?.AdmissionId,
        patientId: row?.MRNo,
        bedId: row?.id,
        bedNo: row?.BedNo,
        patientName: row?.PatientName,
      };
      getStartMonitor(tempObj)
        .then((resposnse) => resposnse.data)
        .then((res) => {
          if (res.statusCode === 200) {
            const updatedData = dataResult.map((item) =>
              item.id === row.id
                ? {
                    ...item,
                    Action: item?.Action === 1 ? "Stop" : "Start",
                  }
                : item
            );
            successAlert(res.message);
            setDataResult(updatedData);
          } else {
            successAlert(res.message);
          }
        })
        .catch((error) => errorAlert(error.message));
    };
    return (
      <>
        {header === "Action" && (
          <button
            type="button"
            onClick={handleToggle}
            className={`w-16 whitespace-nowrap py-0.2 my-0.5 cursor-pointer capitalize px-2 text-center text-[12px] font-normal rounded-lg border
                        ${
                          row?.Action === 0
                            ? "text-[#039855] bg-[#D1FADF] border-[#6EE7B7]"
                            : "text-[#D92D20] bg-[#FEE4E2] border-[#FECACA]"
                        }`}
          >
            {row?.Action === 0 ? "Start" : "Stop"}
          </button>
        )}
      </>
    );
  };

  React.useMemo(() => {
    populateTable();
  }, [listingObject?.searchId, listingObject?.searchString]);

  return (
    <div className="pt-16">
      <h1 className="text-center text-lg font-semibold">Patient Monitoring</h1>

      <div className="gap-2 items-center  grid grid-cols-7 pt-2">
        {/* Patient Dropdown */}
        <div className="col-span-2">
          <SearchDropdown
            control={control}
            searchIcon={true}
            placeholder={"Patient Name/UHD"}
            name={"patientName"}
            label="Search Patient Name"
            onChange={(e) => setPatientName(e.target.value)}
            handleInputChange={(e) => {}}
            isClearable={true}
          />
        </div>

        {/* Bed No */}
        <div>
          <DropdownField
            placeholder={"Bed No"}
            // dataArray={bedArr}
            clearable={true}
            name={"bedNo"}
            control={control}
            fullWidth
            label="Bed No"
            variant="outlined"
            size="small"
          />
        </div>

        {/* ICU */}
        <div>
          <DropdownField
            placeholder={"Ward"}
            // dataArray={icuWardArr}
            name={"ward"}
            control={control}
            fullWidth
            label="Ward"
            variant="outlined"
            size="small"
          />
        </div>

        {/* Doctor */}
        <div>
          <DropdownField
            placeholder={"Doctor"}
            // dataArray={doctorArr}
            name={"doctor"}
            control={control}
            fullWidth
            label="Doctor"
            variant="outlined"
            size="small"
          />
        </div>

        {/* Radio Field */}

        <div className="flex  gap-4 mx-2 col-span-2">
          <div className="flex space-x-2 ">
            <label htmlFor="" className="font-semibold text-gray-600">
              Status &nbsp; : &nbsp;
            </label>
            <RadioField dataArray={action} name={"action"} control={control} />
          </div>

          <div className="flex gap-2">
            <CommonButton
              type="button"
              searchIcon={true}
              className={"bg-[#073762] text-white"}
              onClick={populateTable}
            />
            <CommonButton
              type="button"
              className={"border border-customRed text-customRed"}
              label={"Reset"}
              onClick={() => {
                reset();
              }}
            />
          </div>
        </div>
      </div>

      <div className="">
        {isShowSpinner ? (
          <div className="flex justify-center my-28">
            <LoadingSpinner />
          </div>
        ) : (
          <div>
            {dataResult && dataResult.length > 0 ? (
              <CommonDynamicTableNew
                dataResult={dataResult}
                // rowsPerPage={rowsPerPage}
                // renderActions={renderActions}
                renderInput={renderInput}
                // setPage={setPage}
                // count={count}
                // page={page}
                // populateTable={populateTable}
                highlightRow={false}
                // setRowsPerPage={setRowsPerPage}
                removeHeaders={["id", ""]}
                editableColumns={["Action"]}
                tableClass={"capitalize h-[500px]"}
              />
            ) : (
              <>
                {!isShowSpinner && (
                  <p className="text-center  my-28 w-full text-gray-600">
                    No Record Found<span className="animate-pulse">...</span>
                  </p>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientMonitoring;
